<div class="row mb-2">
    <div class="col pl-0">
        <div widget class="card border-0 box-shadow">
            <div class="card-header transparent  text-muted">
                <!-- Add Evv Timesheets -->
                <div class="row">
                    <div class="col-lg-6">
                        <h4 class="mb-0 font-header">Add Visits</h4>
                    </div>

                </div>
            </div>
            <div class="card-body  widget-body pb-0 pt-2 mb-4">
                <!-- row 1 -->
                <div class="row">
                    <div class="col-lg-5" style="border-right: solid 2px #502189;">
                        <!-- Client Name -->
                        <div class="row ">
                            <div class="col-lg-4">
                                <label>Client
                                    Name</label>
                            </div>
                            <div class="col-lg-8">

                                <ng-select class="w-100" [searchable]="true" [items]="ClientDropdown" [clearable]="true"
                                    bindLabel="Value" bindValue="Key" [(ngModel)]="ClientEditFilter" (ngModelChange)="GetMappedEmployees();
                            GetEmployeePayrateForClient();clearFields()">
                                </ng-select>
                            </div>
                        </div>
                        <!-- Employee Name -->
                        <div class="row mt-3">
                            <div class="col-lg-4">
                                <label>Employee
                                    Name</label>
                            </div>
                            <div class="col-lg-8">
                                <ng-select [searchable]="true" [(ngModel)]="EmployeeEditFilter"
                                    (ngModelChange)="getRelationship();GetEmployeePayrateForClient();"
                                    [disabled]="ClientEditFilter==null || ClientEditFilter==undefined || ClientEditFilter==''"
                                    [clearable]="true" bindLabel="employeeName" bindValue="employeeId"
                                    [items]="EmployeeMappedList" class="w-100">
                                </ng-select>
                            </div>
                        </div>
                        <!-- Relationship -->
                        <div class="row mt-3">
                            <div class="col-lg-4">
                                <label>Relationship</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" [(ngModel)]="RelationshipEditFilter" class="w-100" disabled>
                            </div>
                        </div>
                        <!-- start Date -->
                        <div class="row mt-3">
                            <div class="col-lg-4">
                                <label>Start
                                    Date</label>
                            </div>
                            <div class="col-lg-8">
                                <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy" [disabled]="ClientEditFilter==null || ClientEditFilter==undefined || ClientEditFilter==''||
                                    
                                    EmployeeEditFilter==null || EmployeeEditFilter==undefined || EmployeeEditFilter==''
                                    " [selDate]="FromDateFilter"
                                    (inputFieldChanged)="DateFormat($event,'inputchanged','SaveFromDate')"
                                    (dateChanged)="DateFormat($event,'datechanged','SaveFromDate')">
                                </my-date-picker>
                            </div>
                        </div>
                        <!-- End Date -->
                        <div class="row mt-3">
                            <div class="col-lg-4">
                                <label>End
                                    Date</label>
                            </div>
                            <div class="col-lg-8">
                                <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy" [disabled]="ClientEditFilter==null || ClientEditFilter==undefined || ClientEditFilter==''||
                                    EmployeeEditFilter==null || EmployeeEditFilter==undefined || EmployeeEditFilter==''
                                    " [selDate]="EndDateFilter"
                                    (inputFieldChanged)="DateFormat($event,'inputchanged','SaveEndDate')"
                                    (dateChanged)="DateFormat($event,'datechanged','SaveEndDate')">
                                </my-date-picker>
                            </div>
                        </div>
                        <!-- Authorization Service -->
                        <div class="row mt-3">
                            <div class="col-lg-4">
                                <label>Authorization Service</label>
                            </div>
                            <div class="col-lg-8">
                                <ng-select [searchable]="true" [(ngModel)]="ServiceEditFilter" [clearable]="true"
                                    bindLabel="serviceCodeName" bindValue="id" disabled [items]="ActiveAuthorizationList"
                                    class="w-100">
                                </ng-select>
                            </div>
                        </div>
                        <!-- Balance Amount -->
                        <div class="row mt-3">
                            <div class="col-lg-4">
                                <label>Remaining Amount</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" [(ngModel)]="RemainingAmountEditFilter" class="w-100" disabled>
                            </div>
                        </div>
                        <!-- Payor -->
                        <div class="row mt-3">
                            <div class="col-lg-4">
                                <label>Payor</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" [(ngModel)]="PayorEditFilter" class="w-100" disabled>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-lg-4">
                                <label>Reason</label><sup class="super-script">*</sup>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" [(ngModel)]="reasonForModify" class="form-control">
                            </div>
                        </div>
                        <!-- Rate -->
                        
                    </div>
                    <!-- Authorization Details -->
                    <div class="col-lg-7">
                        <div class="row">
                            <label class="subtablelabel mt-3" *ngIf="isAuthorizationDetails">Authorization
                                Details</label>
                            <label class="subtablelabel mt-3 text-center" *ngIf="isNoAuthorizationDetails"
                                style="font-weight: bold;">No Authorization
                                Details</label>
                        </div>
                        <div class="row" *ngIf="isAuthorizationDetails">
                            <div class="col-lg-12">
                                <ejs-grid #gridActiveAuthorization [dataSource]='ActiveAuthorizationList'
                                    [rowHeight]='40' [pageSettings]='AuthorizationinitialPage' [allowPaging]='true'
                                    (queryCellInfo)='customiseCell($event)' (rowSelected)='rowSelected($event)'
                                    [allowResizing]='true'>
                                    <e-columns>
                                        <!-- startdate -->
                                        <e-column field="startDate" headerText="Start Date" minWidth=120
                                            [format]='formatOptions' type="date">
                                            <ng-template #filterTemplate let-row>
                                            </ng-template>
                                        </e-column>
                                        <!-- enddate -->
                                        <e-column field="endDate" headerText="End Date" minWidth=120
                                            [format]='formatOptions' type="date">
                                            <ng-template #filterTemplate let-row>
                                            </ng-template>
                                        </e-column>
                                        <!-- Service -->
                                        <e-column minWidth=100 field="servicenamewithcode" headerText="Service">
                                            <ng-template #filterTemplate let-row>
                                            </ng-template>
                                        </e-column>
                                        <e-column minWidth=100 field="authNote" headerText="AuthNote">
                                            <ng-template #filterTemplate let-row>
                                            </ng-template>
                                        </e-column>
                                       
                                        <e-column minWidth=100 field="serviceGroup" headerText="Service Group">
                                            <ng-template #filterTemplate let-row>
                                            </ng-template>
                                        </e-column>



                                        <!-- BalanceAmount -->
                                        <e-column field="balanceAmount" headerText="Remaining Amount" minWidth=120>
                                            <ng-template #filterTemplate let-row>
                                            </ng-template>
                                        </e-column>


                                        <!-- Payor -->
                                        <e-column field="payor" headerText="Payor" minWidth=120>
                                            <ng-template #filterTemplate let-row>
                                            </ng-template>
                                        </e-column>
                                        <!-- Rate -->
                                        <e-column minWidth=100 field="rate" headerText="Rate">
                                            <ng-template #filterTemplate let-row>
                                            </ng-template>
                                        </e-column>
                                        <e-column minWidth=100 field="insuranceNumber" headerText="InsuranceNumber">
                                            <ng-template #filterTemplate let-row>
                                            </ng-template>
                                        </e-column>

                                    </e-columns>
                                </ejs-grid>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row pt-3">

                    <div class="table-responsive">
                        <table class="table  table-hover " style="margin-top: 3px;">
                            <tr style=" background-color:  #502189 !important;height: 32px">
                                <th class="pointer" class="text-center" style="background-color: #502189;color:#fff ">
                                    Services
                                </th>
                                <th class="pointer" class="text-center fms-color">Day
                                </th>
                                <th class="pointer" class="text-center">Start Time
                                </th>
                                <th class="pointer" class="text-center">End Time
                                </th>
                                <th class="pointer" class="text-center">Time
                                </th>
                                <th class="pointer" class="text-center">Rate
                                </th>
                                <th class="pointer" class="text-center">Hours
                                </th>

                                <th class="pointer" class="text-center">Amount
                                </th>


                            </tr>
                            <tbody>

                                <tr class="collapsible"
                                    *ngFor="let assignTimesheetDetails of EvvTimesheetOrderList;let TimesheetIndex=index">
                                    <td class="text-center" tabindex="-1">
                                        {{assignTimesheetDetails.Authorizationservice}}
                                    </td>
                                    <td class="text-center" tabindex="-1">
                                        {{assignTimesheetDetails.Days}}
                                    </td>
                                    <td class="text-center" tabindex="-1">
                                        {{assignTimesheetDetails.StartDate}}
                                    </td>
                                    <td class="text-center" tabindex="-1">
                                        {{assignTimesheetDetails.EndDate}}
                                    </td>
                                    <td class="text-center" tabindex="-3">
                                        <!-- <button type="button" class="btn blue-btn" data-bs-toggle="modal" data-bs-target="#modalacceptrequests"  (click)="newData(assignTimesheetDetails,TimesheetIndex)"
                                 >Add Time</button> -->
                                        <button class="btn" data-bs-target="#timemodal" data-bs-toggle="modal"
                                            (click)="AddTime(TimesheetIndex,assignTimesheetDetails)">Add Time</button>

                                    </td>
                                    <td class="text-center" tabindex="-1">
                                        {{assignTimesheetDetails.Rate}}
                                    </td>
                                    <td class="text-center" tabindex="-1">
                                        {{assignTimesheetDetails.hours}}
                                    </td>
                                    <td class="text-center" tabindex="-1">
                                        {{assignTimesheetDetails.totalAmount}}
                                    </td>
                                </tr>


                            </tbody>
                        </table>
                    </div>


                </div>
                <!-- save buttons -->
                <div class="row">
                    <div class="col-lg-6">
                        <label>
                            Entered Total Hours :{{enteredhour}} hrs &nbsp;&nbsp;{{enteredminutes}} mins
                        </label>
                    </div>
                    <div class="col-lg-5 text-end">
                        <label>
                            Total Amount :{{showTotalamount}}
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                    </div>
                    <div class="col-lg-6 mt-3">
                        <div class="row" class="timesheet-footer">
                            <button class="btn  blue-btn btn-sm  savealign"
                                [disabled]="ClientEditFilter==null || ClientEditFilter==undefined || ClientEditFilter=='' ||
                            EmployeeEditFilter==null || EmployeeEditFilter==undefined || EmployeeEditFilter=='' ||
                            ServiceEditFilter==null || ServiceEditFilter==undefined || ServiceEditFilter=='' || 
                            
                            FromDateFilter==null || FromDateFilter==undefined || FromDateFilter=='' || reasonForModify==null || reasonForModify==''
                             || reasonForModify==undefined ||  EndDateFilter==null || EndDateFilter==undefined || EndDateFilter=='' || IsButtonDisable"
                                (click)="SaveEVVTimesheets()">Save
                                & Close</button>
                            <button class="btn  blue-btn btn-sm savealign"
                                (click)="backtoEvvTimesheetList()">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Insufficient Balance -->
<span id="openValidationModal" data-bs-toggle="modal" data-bs-target="#Validationmodal"></span>
<div class="modal fade" id="Validationmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Insufficient Balance</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="cancelValidation()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <p>Entered Amount will exceed the remaining budget amount.
                            Are you sure you want to save?</p>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn  btn-sm" data-bs-dismiss="modal" (click)="SaveEVVTimesheets()">
                    <span> Yes
                    </span> </button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal"
                    (click)="cancelValidation()">No</button>
            </div>
        </div>
    </div>
</div>

<span id="openModal2" data-bs-toggle="modal" data-bs-target="#timemodal"></span>
<div class="modal hide fade modalbackgrod" id="timemodal" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5>Add Time</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="alert alert-warning alert-dismissible fade show" *ngIf="saveEvvErr!=''" role="alert">
                <p>{{saveEvvErr}}</p>

                <button type="button" class="btn-close" data-dismiss="alert" aria-label="Close" (click)="saveEvvErr = ''">
                    <span aria-hidden="true">&times;</span>
                </button>

            </div>
            <div class="modal-body ">
                <div class="row">
                    <div class="col-lg-12">
                        <table class="table table-bordered table-responsive">
                            <tr>

                                <th><b>Start Time</b>
                                </th>
                                <th><b>End Time

                                    </b>
                                </th>

                                <th style="width: 100px;"><b>Hours</b></th>
                                <th></th>
                            </tr>
                            <tr style="border: 1px gray;"
                                *ngFor="let multipleItems of Multiplesessionlist;let indextime = index">
                                <td><input type="time" class="form-control" [(ngModel)]="multipleItems.visitStartTime"
                                        (ngModelChange)="hourscal(multipleItems.visitStartTime,multipleItems.visitEndTime,indextime,multipleItems)">
                                </td>
                                <td><input type="time" class="form-control" [(ngModel)]="multipleItems.visitEndTime"
                                        (ngModelChange)="hourscal(multipleItems.visitStartTime,multipleItems.visitEndTime,indextime,multipleItems)">
                                </td>
                                <td><input type="number" class="form-control" [(ngModel)]="multipleItems.totalHours"
                                        disabled></td>
                                <td> <button class="btn btn" *ngIf="indextime==0" (click)="AddTimeList()"><i
                                            class="fa fa-plus-circle"></i></button>

                                    <button class="btn btn" *ngIf="ContactColumn && indextime!=0"
                                        (click)="removeTime(indextime);"><i class="fa fa-trash"></i></button>
                                    <button class="btn btn ms-2"
                                        (click)="cleartimelist(multipleItems,indextime)">Clear</button>
                                </td>



                            </tr>


                        </table>
                    </div>

                </div>
            </div>
            <div class="modal-footer">

                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
                    (click)="closeTimeList()">close</button>
            </div>
        </div>
    </div>
</div>


<span id="errorpopup" data-bs-toggle="modal" data-bs-target="#errormodal"></span>
    <div class="modal" tabindex="-1"  id="errormodal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" style="color: #502189;"><b>Error Status</b></h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
            </div>
            <div class="modal-body mt-3">
               <div *ngFor="let items of errorlist">
              <b class="text-danger">"{{items}}"</b>
            </div>
            </div>
            <div class="modal-footer mt-3">
              <button type="button" class="btn btn-sm" data-bs-dismiss="modal" >Close</button>
           
            </div>
          </div>
        </div>
      </div>


    

